import MySessions from './pages/MySessions';
import FAQ from './pages/FAQ';
import Support from './pages/Support';
import Contact from './pages/Contact';
import TermsOfService from './pages/TermsOfService';
import React from 'react';
import  GlobalStyle  from './global-styles';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom'
// import Navbar from "./components/Navbar/Navbar";
// import './App.css';
import Home from './pages/HomePage/Home';
import Services from './pages/Services/Services';
import Products from './pages/Products/Products';
import SignUp from './pages/Signup/Signup';
import Login from './pages/SignIn/Login';
import BookSession from './pages/Counseling/Booksession';
// import ContactUs from './pages/ContactUs/ContactUs';
// import {FooterContainer} from './containers/footer';
import ScrollToTop from './components/ScrollToTop';
import { Navbar, Footer } from './components';
import Success from './pages/Counseling/Success';
import FreelanceSuccess from './pages/Counseling/FreelanceSuccess';
import HowItWorks from './pages/HowItWorks';
import Profile from './pages/Profile/Profile';

function App() {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <Navbar />
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/services' element={<Services />} />
          <Route path='/products' element={<Products />} />
          <Route path='/sign-up' element={<SignUp />} />
          <Route path='/how-it-works' element={<HowItWorks />} />
          <Route path='/terms-of-service' element={<TermsOfService />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/support' element={<Support />} />
          <Route path='/sign-in' element={<Login />} />
          <Route path='/counseling' element={<BookSession />} />
          <Route path="/success" element={<Success />} />
          <Route path="/freelance-success" element={<FreelanceSuccess />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/my-sessions" element={<MySessions />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
        {/* <Home /> */}
      {/* <FooterContainer /> */}
      <Footer />
    </Router>
  );
}

export default App;
